// API Configuration
const RAW_API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
export const API_BASE_URL = RAW_API_BASE_URL.replace(/\/+$/, '');

// File upload configuration
export const ACCEPTED_FILE_TYPES = [
  // Images
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  // Documents
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  // Audio
  'audio/mpeg',
  'audio/wav',
  'audio/ogg',
  'audio/webm',
  // Video
  'video/mp4',
  'video/webm',
  'video/quicktime'
].join(',');

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

// Audio recording configuration
export const AUDIO_RECORDER_CONFIG = {
  mimeType: 'audio/webm;codecs=opus',
  audioBitsPerSecond: 128000,
  echoCancellation: true,
  noiseSuppression: true,
  sampleRate: 44100
};

// Message types
export const MESSAGE_TYPES = {
  TEXT: 'TEXT',
  AUDIO: 'AUDIO',
  FILE: 'FILE',
  IMAGE: 'IMAGE'
} as const;

// Message status
export const MESSAGE_STATUS = {
  SENDING: 'sending',
  SENT: 'sent',
  FAILED: 'failed'
} as const;

// User roles
export const USER_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant'
} as const;

// Time formatting
export const formatMessageDate = (date: Date): string => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  if (date.toDateString() === today.toDateString()) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  } else {
    return date.toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short' });
  }
};

// Utility functions
export const roundToNearestSecond = (duration: number): number => {
  return Math.round(duration * 10) / 10;
};

export const generateTempId = (prefix: string = 'temp'): string => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const createTempThreadId = (): string => {
  return `temp-thread-${Date.now()}`;
}; 